import { Text } from '@eqi-investimentos/react';
import { MODAL_INVEST_ID } from '@/viewModels/InvestViewModel/utils';
import { InvestView } from '@/views/InvestView/InvestView';
import { Drawer } from '../Drawer';
export const SectionModalInvest = () => {
  return <Drawer id={MODAL_INVEST_ID} customBackButtonAction={handleCustomBackButton} showIconButton={false} bodyProps={{
    p: 0
  }} closeButtonProps={{
    top: '3.125rem'
  }} headerProps={{
    pl: '3.4375rem',
    pr: '3rem',
    py: '2.8125rem'
  }} headerContent={<Text size="xl" color="content.primary">
          Investir
        </Text>} data-sentry-element="Drawer" data-sentry-component="SectionModalInvest" data-sentry-source-file="index.tsx">
      <InvestView data-sentry-element="InvestView" data-sentry-source-file="index.tsx" />
    </Drawer>;
};
const handleCustomBackButton = () => {
  window.dispatchEvent(new Event(`action-back-button-drawer-${MODAL_INVEST_ID}`));
};